/**
 * Mobile Settings — tampilan HP (OLED dll).
 * Konfigurasi bot/API tetap di desktop.
 */
import { useState } from 'react';
import { brand, copy } from './brand';

export function MobileSettingsPage() {
  const [oled, setOled] = useState(() => {
    try {
      return localStorage.getItem('tc-mob-oled') === '1';
    } catch {
      return false;
    }
  });

  const toggleOled = () => {
    const next = !oled;
    setOled(next);
    try {
      localStorage.setItem('tc-mob-oled', next ? '1' : '0');
    } catch {
      /* ignore */
    }
    window.dispatchEvent(new Event('tc-mob-oled'));
    if (navigator.vibrate) navigator.vibrate(8);
  };

  return (
    <div className="tc-mob-page tc-mob-page--ht tc-mob-page--eg">
      <div className="tc-mob-page__header tc-mob-page__header--eg">
        <div className="tc-mob-page__title">{copy.settings.title}</div>
        <div className="tc-mob-page__sub">{copy.settings.sub}</div>
      </div>

      <div className="tc-mob-form__section tc-mob-card--eg">
        <div className="tc-mob-form__section-title">Tampilan di HP</div>

        <label className="tc-mob-toggle">
          <span>
            <strong>OLED pure black</strong>
            <small>Latar hitam pekat — hemat baterai (S24 / OLED)</small>
          </span>
          <input type="checkbox" checked={oled} onChange={toggleOled} />
        </label>
      </div>

      <div className="tc-mob-form__section tc-mob-card--eg">
        <div className="tc-mob-form__section-title">Tentang desk</div>
        <p className="tc-mob-hint" style={{ marginBottom: 8 }}>
          <strong>{brand.company}</strong> · {brand.poweredBy}
        </p>
        <p className="tc-mob-hint">{copy.settings.desktopNote}</p>
      </div>

      <div className="tc-mob-form__section tc-mob-card--eg">
        <div className="tc-mob-form__section-title">Tips</div>
        <ul className="tc-mob-tips">
          <li>Geser kiri/kanan untuk ganti tab</li>
          <li>Tarik ke bawah untuk muat ulang data</li>
          <li>Tekan lama angka besar untuk nilai penuh (di halaman lain)</li>
        </ul>
      </div>
    </div>
  );
}
